<template>
  <b-modal
    id="my-social-share-popup"
    centered
    hide-footer
    hide-header
    body-class="my-social-share-popup"
    size="sm"
    @show="beforeOpen"
    @hidden="isHide"
  >
    <button
      @click="hideModal"
      class="tw-absolute tw-top-[20px] tw-right-[20px] tw-grid tw-place-items-center tw-w-[40px] tw-h-[40px] tw-border-[1px] tw-border-transparent tw-text-[#d9d9d9] hover:tw-text-[var(--my-white)] tw-transition-colors"
    >
      <icon-close />
    </button>

    <p class="tw-mb-[30px] tw-text-[20px] tw-font-bold">
      {{
        $t("donor_dashboard.my_contacts_share_popup_title", "Share with your friends and family!")
      }}
    </p>

    <div class="tw-flex tw-flex-wrap tw-justify-center tw-gap-[10px] tw-mb-[40px]">
      <a
        class="share-btn"
        :href="`https://www.facebook.com/sharer/sharer.php?u=${encodedUrl}`"
        target="_blank"
      >
        <icon-social-facebook />
      </a>
      <a
        class="share-btn"
        :href="`https://twitter.com/intent/tweet?url=${encodedUrl}&text=${encodedTitle}`"
        target="_blank"
      >
        <icon-social-twitter />
      </a>
      <a
        class="share-btn"
        :href="`https://t.me/share/url?url=${encodedUrl}&text=${encodedTitle}`"
        target="_blank"
      >
        <icon-social-telegram />
      </a>
      <a
        class="share-btn"
        :href="`https://wa.me/?text=${encodedTitle}%20${encodedUrl}`"
        target="_blank"
      >
        <icon-social-whatsapp />
      </a>
      <a
        class="share-btn"
        :href="`https://www.linkedin.com/sharing/share-offsite/?url=${encodedUrl}`"
        target="_blank"
      >
        <icon-social-linkedin />
      </a>
    </div>

    <button
      @click="copyUrl"
      class="tw-flex tw-items-center tw-justify-between tw-w-full tw-h-[30px] tw-border-b-[1px] tw-border-b-[var(--my-white)] tw-text-[13px] tw-bg-transparent"
    >
      {{ url }}
      <icon-copy />
    </button>
  </b-modal>
</template>

<script>
import iconClose from "@/views/donor-dashboard/my-contacts/icons/close.vue";
import iconCopy from "@/views/donor-dashboard/my-contacts/icons/copy.vue";
import { mapState } from "vuex";
import iconSocialFacebook from "@/views/donor-dashboard/my-contacts/icons/social/facebook.vue";
import iconSocialTwitter from "@/views/donor-dashboard/my-contacts/icons/social/twitter.vue";
import iconSocialTelegram from "@/views/donor-dashboard/my-contacts/icons/social/telegram.vue";
import iconSocialWhatsapp from "@/views/donor-dashboard/my-contacts/icons/social/whatsapp.vue";
import iconSocialLinkedin from "@/views/donor-dashboard/my-contacts/icons/social/linkedin.vue";

export default {
  name: "add-social-share-popup",

  data() {
    return {
      loading: false,
    };
  },

  computed: {
    ...mapState({
      campaignId: (state) => state.donorMyContacts.campaignId,
      campaigns: (state) => state.donorMyContacts.campaigns,
    }),

    currentCampaign() {
      const findCampaign = this.campaigns.find((item) => item.id === this.campaignId);
      if (findCampaign) {
        return {
          shortLink: findCampaign.attributes?.shortlink,
          title: findCampaign.attributes?.campaigntitle,
        };
      }

      return null;
    },

    encodedUrl() {
      return encodeURIComponent(this.url);
    },

    url() {
      return this.currentCampaign?.shortLink
        ? `https://charidy.com/${this.currentCampaign?.shortLink}`
        : "https://charidy.com";
    },

    encodedTitle() {
      return encodeURIComponent(this.currentCampaign?.title || "charidy.com");
    },
  },

  mounted() {},

  beforeDestroy() {},

  methods: {
    async copyUrl() {
      {
        try {
          if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(this.url);
          } else {
            const textArea = document.createElement("textarea");
            textArea.value = this.url;
            textArea.style.position = "fixed";
            textArea.style.left = "-999999px";
            textArea.style.top = "-999999px";
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();
            document.execCommand("copy");
            textArea.remove();
          }
        } catch (err) {
          console.error("Error copying text: ", err);
        }
      }
    },

    beforeOpen() {},

    isHide() {},

    openModal() {
      this.$root.$emit("bv::show::modal", "my-social-share-popup");
    },

    hideModal() {
      this.$root.$emit("bv::hide::modal", "my-social-share-popup");
    },
  },

  components: {
    iconClose,
    iconCopy,
    iconSocialFacebook,
    iconSocialTwitter,
    iconSocialTelegram,
    iconSocialWhatsapp,
    iconSocialLinkedin,
  },
};
</script>

<style lang="scss" scoped>
::v-deep #my-social-share-popup .modal-sm {
  @apply tw-max-w-none sm:tw-max-w-[428px];
}

::v-deep .modal-dialog .modal-content {
  @apply tw-rounded-[20px] tw-bg-[var(--my-primary)];
}

::v-deep .modal-dialog .my-social-share-popup {
  @apply tw-p-[50px] tw-rounded-[20px] tw-text-center tw-font-lato tw-text-[var(--my-white)] tw-leading-[var(--my-leading)] tw-bg-[var(--my-primary)];
}

.share-btn {
  @apply tw-flex tw-items-center tw-justify-center tw-w-[40px] tw-h-[40px] tw-rounded-[10px] tw-bg-[#EBE9E9];
  box-shadow: 0px 17px 13.6px rgba(0, 0, 0, 0.07), 0px 7.1px 5.6px rgba(0, 0, 0, 0.05),
    0px 3.8px 3px rgba(0, 0, 0, 0.04), 0px 2.1px 1.7px rgba(0, 0, 0, 0.03),
    0px 1.1px 0.9px rgba(0, 0, 0, 0.02), 0px 0.47px 0.37px rgba(0, 0, 0, 0.01);
}
</style>
